import { _ as e } from "./tslib.es6-7f1b1220.js";
import { c as t, u as i, h as o } from "./lit-element-161a1699.js";
import { p as n, q as s, c as a } from "./decorators-7e9cd43b.js";
import { BaseElement as r } from "./BaseElement.esm.min.js";
import { h as l } from "./host.styles-cf05db22.js";
import { traverseDOMSiblingsByStepAndDirection as d } from "./dom.utils.esm.min.js";
import { MenuItem as u } from "./menu-item.component.esm.min.js";
const c = t`${i(":host {\n  --zui-menu-border-size: 1px;\n  --zui-menu-background: inherit;\n  --zui-menu-border-color: var(--zui-color-menu-border);\n  --zui-menu-border-radius: var(--zui-border-radius-default);\n  --zui-menu-item-count: 9.5;\n  ---zui-menu-max-height: calc(\n    var(--zui-menu-item-count) *\n      (\n        var(--zui-body-font-size) * var(--zui-body-line-height) + calc(var(--zui-gu) * 0.625) + calc(var(--zui-gu) * 0.875)\n      )\n  );\n  --zui-menu-width: 100%;\n  ---zui-menu-shadow: inherit;\n  --zui-menu-margin-top: 0;\n}\n\n:host {\n  box-sizing: border-box;\n  display: block;\n  margin-top: var(--zui-menu-margin-top);\n  width: var(--zui-menu-width);\n  background: var(--zui-menu-background);\n  border: var(--zui-menu-border-size) solid var(--zui-menu-border-color);\n  border-radius: var(--zui-menu-border-radius);\n  box-shadow: var(---zui-menu-shadow);\n  overflow: hidden;\n  transition: box-shadow 0.2s ease;\n}\n\nzui-scrollable-directive {\n  --zui-scrollable-width: calc(var(--zui-menu-width) - (var(--zui-menu-border-size) * 2));\n  --zui-scrollable-max-height: var(---zui-menu-max-height);\n}\n:host([adapt-width]) zui-scrollable-directive {\n  --zui-scrollable-width: 100%;\n}\n:host([overflow=scroll]) zui-scrollable-directive {\n  --zui-scrollable-content-display-mode: block;\n}\n\n:host([adapt-width]) {\n  width: fit-content;\n}\n\n:host(:focus) {\n  outline: 0;\n}\n\n:host([placement^=bottom]) {\n  ---zui-menu-shadow: var(--zui-box-shadow-large);\n}\n\n:host([placement^=top]) {\n  ---zui-menu-shadow: var(--zui-box-shadow-large-inverted);\n}\n\n:host([emphasis=default]) {\n  --zui-menu-background: var(--zui-color-second-hierarchy-bg-default-enabled);\n}\n\n:host([emphasis=active]), :host([emphasis=selected]) {\n  --zui-menu-background: var(--zui-color-second-hierarchy-bg-active-enabled);\n}\n\n:host([emphasis=active-primary]), :host([emphasis=selected-primary]) {\n  --zui-menu-background: var(--zui-color-second-hierarchy-bg-primary-enabled);\n}\n\nslot {\n  display: flex;\n  flex-direction: column;\n}\n:host([adapt-width]) slot, :host([overflow=scroll]) slot {\n  min-width: 100%;\n  width: fit-content;\n}")}`;
let h = class extends r {
  constructor() {
    super(...arguments), this.tabindex = 0, this.ariaActiveDescendant = "", this.role = "menu", this.count = 9.5, this.disabled = !1, this.adaptWidth = !1, this.emphasis = "default", this.overflow = "truncate", this.placement = "bottom-start", this.size = this.hasTouch ? "l" : "s", this.scrollableBackground = "hidden", this.scrollableHitarea = "minimal", this._skipNextFocusDelegation = !1;
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("focus", this._handleFocus), this.addEventListener("keydown", this._handleKeys);
  }
  disconnectedCallback() {
    this.removeEventListener("focus", this._handleFocus), this.removeEventListener("keydown", this._handleKeys), super.disconnectedCallback();
  }
  _handleSlotChange() {
    this._propagateProps();
  }
  _propagateProps() {
    this._itemRefs.forEach((e, t) => {
      this.disabled && (e.disabled = !0), e.disableTruncation = this.adaptWidth || "scroll" === this.overflow, e.size = this.size, e.id = `menu-${t}`;
    });
  }
  _handleFocus() {
    !this.disabled && this._itemRefs.length > 0 && !this._skipNextFocusDelegation && (this._setActiveMenuItem(this._itemRefs[0]), this._skipNextFocusDelegation = !1);
  }
  _handleKeys({
    target: e,
    code: t
  }) {
    let i;
    switch (t) {
      case "ArrowUp":
        i = this._getPreviousMenuItem(e);
        break;
      case "ArrowDown":
        i = this._getNextMenuItem(e);
    }
    i = null != i ? i : e, this._setActiveMenuItem(i);
  }
  _getPreviousMenuItem(e) {
    return d(e, "previous", 1, e => e instanceof u && !e.hasAttribute("disabled"));
  }
  _getNextMenuItem(e) {
    return d(e, "next", 1, e => e instanceof u && !e.hasAttribute("disabled"));
  }
  _setActiveMenuItem(e) {
    e && (this.ariaActiveDescendant = e.id, e.focus());
  }
  _handleMouseOver(e) {
    e.target instanceof u && !e.target.disabled && this._setActiveMenuItem(e.target);
  }
  _handleMouseOut(e) {
    this.ariaActiveDescendant = "", e.target instanceof u && !e.target.disabled && (this._skipNextFocusDelegation = !0, this.focus());
  }
  updated(e) {
    super.updated(e), (e.has("disabled") || e.has("size") || e.has("adaptWidth") || e.has("overflow")) && this._propagateProps(), e.has("count") && this.style.setProperty("--zui-menu-item-count", this.count.toString());
  }
  render() {
    return o`<zui-scrollable-directive background="${this.scrollableBackground}" hitarea="${this.scrollableHitarea}" @mouseover="${this._handleMouseOver}" @mouseout="${this._handleMouseOut}"><slot @slotchange="${this._handleSlotChange}"></slot></zui-scrollable-directive>`;
  }
};
h.styles = [l, c], e([n({
  reflect: !0,
  type: String
})], h.prototype, "tabindex", void 0), e([n({
  reflect: !0,
  attribute: "aria-activedescendant"
})], h.prototype, "ariaActiveDescendant", void 0), e([n({
  reflect: !0,
  type: String
})], h.prototype, "role", void 0), e([n({
  reflect: !0,
  type: Number
})], h.prototype, "count", void 0), e([n({
  reflect: !0,
  type: Boolean
})], h.prototype, "disabled", void 0), e([n({
  reflect: !0,
  type: Boolean,
  attribute: "adapt-width"
})], h.prototype, "adaptWidth", void 0), e([n({
  reflect: !0,
  type: String
})], h.prototype, "emphasis", void 0), e([n({
  reflect: !0,
  type: String
})], h.prototype, "overflow", void 0), e([n({
  reflect: !0,
  type: String
})], h.prototype, "placement", void 0), e([n({
  reflect: !0,
  type: String
})], h.prototype, "size", void 0), e([n({
  reflect: !0,
  type: String,
  attribute: "scrollable-background"
})], h.prototype, "scrollableBackground", void 0), e([n({
  reflect: !0,
  type: String,
  attribute: "scrollable-hitarea"
})], h.prototype, "scrollableHitarea", void 0), e([s(void 0, !0, "zui-menu-item")], h.prototype, "_itemRefs", void 0), h = e([a("zui-menu")], h);
export { h as Menu };
